module.exports = __webpack_public_path__ + "img/prize2.f5aa4a96.png";